<template>
<div>
  <nav class="navbar navbar-expand-lg p-4" style="background: #2c2d3a">
          <div class="row">
          <img class="img-fluid pl-3" style="height: 33px" src="../assets/Logo_Print-01.png">
          <button class="navbar-toggler ml-5"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarNav"
                  aria-controls="navbarNav"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  style="z-index:99 !important">
            <span class="navbar-toggler-icon"></span>
          </button>
          </div>
          <button class="navbar-toggler" @click="changeDisplay" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <i class="fas fa-bars" style="color: white"></i>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav navbarLinkClass ml-auto">
              <li class="nav-item navList p-1 pl-0">
                <a class="nav-link navlinkFont pb-0" href="http://docs.ambeedata.com/">Docs</a>
              </li>
              <li class="nav-item navList p-1 pl-0">
                <a class="nav-link navlinkFont pb-0" href="https://getambee.com/section/docs.html">API</a>
              </li>
              <!-- <li class="nav-item navList p-1 pl-0">
                <a class="nav-link navlinkFont pb-0" href="#">Live Map</a>
              </li> -->
              <li class="nav-item navList p-1 pl-0">
                <a class="nav-link navlinkFont pb-0" href="https://getambee.com/section/aboutus.html">About Us</a>
              </li>
              <li class="nav-item navList p-1 pl-0">
                <a class="nav-link navlinkFont pb-0" href="https://www.amazon.in/Ambee-Air-Quality-Monitor/dp/B07RPF9V63">Store</a>
              </li>
              <li class="nav-item navList sigunupList p-1 pl-0">
                <a class="nav-link navlinkFont pb-0 signupLink" style="color: white" @click="route">Login/Sign up</a>
              </li>
            </ul>
          </div>
        </nav>
</div>
</template>
<script>
import $ from 'jquery'

export default {
  props: {
  },
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {
    // if (this.$route.path === '/signup' || this.$route.path === '/login') {
    //   $('.sigunupList').css('border-bottom', '1px solid #2295C8')
    //   $('.signupLink').css('color', '#2295C8')
    // }
  },
  computed: {
  },
  methods: {
    changeDisplay() {
      if ($('#navbarSupportedContent')[0].style['display'] === 'none' || $('#navbarSupportedContent')[0].style['display'] === '') {
        $('#navbarSupportedContent').delay(300).fadeIn();
      } else {
        $('#navbarSupportedContent').delay(300).fadeOut();
      }
    },
    route() {
      this.$router.push('/under-Maintenance')
    }
  }
}
</script>
<style scoped>
.nav-item:hover {
  color: #2295C8;
}
.navlinkFont {
  font-family: "Ubuntu";
  font-size: 14px;
  color: white;
  text-align: left;
}
.navlinkFont:hover {
 color: #2295C8 !important;
}
.navList:hover {
  border-bottom: 1px solid #2295C8;
  /* text-decoration: underline; */
}
</style>
